import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import AiReports from "../modules/AiReports/AiReportsPage";

export function AiReportsPage() {
  const {formatMessage} = useIntl();
  const headerMessage = formatMessage({id: "ai-reports-page-title", defaultMessage: "AI reports"});
  const header = useHeader();
  header.setTitle(headerMessage);
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <AiReports/>;
}